"use client";

import type { RegionCode } from "@/lib/community/constants";
import type { PublicCommunityRegion } from "@/lib/community/types";
import { LocationFilterOption } from "./location-filter-option";

const MAIN_REGION_CODES: RegionCode[] = [
  "EUROPE",
  "NORTH_AMERICA",
  "ASIA",
  "OCEANIA",
];

interface RegionFilterChipsProps {
  selected: RegionCode | null;
  onChange: (code: RegionCode | null) => void;
  regions: PublicCommunityRegion[];
  layout?: "grid" | "list";
}

export function RegionFilterChips({
  selected,
  onChange,
  regions,
  layout = "grid",
}: RegionFilterChipsProps) {
  const isList = layout === "list";

  const displayedRegions = isList
    ? regions
    : regions.filter((r) => MAIN_REGION_CODES.includes(r.code as RegionCode));

  return (
    <div
      className={
        isList
          ? "flex flex-col gap-1"
          : "grid grid-cols-2 sm:grid-cols-4 gap-2"
      }
    >
      {displayedRegions.map((region) => {
        const regionCode = region.code as RegionCode;
        return (
          <LocationFilterOption
            key={region.code}
            emoji={region.emoji_flag}
            label={region.name}
            selected={selected === regionCode}
            onClick={() =>
              onChange(selected === regionCode ? null : regionCode)
            }
            compact={isList}
          />
        );
      })}
    </div>
  );
}
